import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'variant-switcher';
const BLOCK_ID = 'variant-switcher';
const PLACEHOLDER_LABEL = 'Varianten';

const VARIANT_LAYOUT_OPTIONS = [
    { value: 'pills', name: 'Pillen' },
    { value: 'cards', name: 'Karten' },
];

const GROUPING_OPTIONS = [
    { value: 'none', name: 'Keine' },
    { value: 'byYear', name: 'Nach Jahr' },
    { value: 'byName', name: 'Nach Name' },
    { value: 'byId', name: 'Nach ID' },
];

export default function variantSwitcher(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-variant-switcher') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: 'Varianten',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-variant-switcher',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'select',
                        name: 'layout',
                        label: 'Layout',
                        options: VARIANT_LAYOUT_OPTIONS,
                        value: 'pills',
                        changeProp: true,
                    },
                    {
                        type: 'select',
                        name: 'grouping',
                        label: 'Gruppierung',
                        options: GROUPING_OPTIONS,
                        value: 'none',
                        changeProp: true,
                    },
                    {
                        type: 'checkbox',
                        name: 'limitCardsToSelectedGroup',
                        label: 'Karten auf ausgewählte Gruppe beschränken',
                        value: false,
                        changeProp: true,
                    },
                ],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Varianten',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M4 5h6v6H4V5Zm0 8h6v6H4v-6Zm10-8h6v6h-6V5Zm0 8h6v6h-6v-6ZM6 7v2h2V7H6Zm0 8v2h2v-2H6Zm10-8v2h2V7h-2Zm0 8v2h2v-2h-2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-variant-switcher',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
